import {
  Card,
  CardBody,
  CardHeader,
  CircularProgress,
  Flex,
  Heading,
  HStack,
  Icon,
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { FiUsers } from 'react-icons/fi';
import { IoKeyOutline } from 'react-icons/io5';
import ProtectedButton from 'shared/components/ProtectedButton';
import ProtectedComponent from 'shared/components/ProtectedComponent';
import { usePermissions } from 'shared/hooks/usePermissions';
import { AppUser } from 'shared/models/appUser';
import { useAppTabContext } from '../AppContext';
import NewPasswordModal from '../components/NewPassword';

const Users = () => {
  const { d } = usePermissions();

  const { users, loadingUsers, openCreateTempUserModal } = useAppTabContext();

  const [newPasswordUser, setNewPasswordUser] = useState<AppUser>();

  return (
    <Card>
      <NewPasswordModal
        user={newPasswordUser}
        onClose={() => setNewPasswordUser(undefined)}
      />
      <CardHeader>
        <HStack>
          <Icon as={FiUsers} />
          <Heading size="sm">Usuários</Heading>

          <ProtectedButton
            permission="installation-card-users-user_temp-create"
            isDisabled={loadingUsers}
            leftIcon={<FaPlus />}
            onClick={openCreateTempUserModal}
            variant="filled"
            size="sm"
            py="1.5rem"
            ml="auto"
          >
            Criar usuário temporário
          </ProtectedButton>
        </HStack>
      </CardHeader>

      <CardBody>
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th textAlign="center">Usuário</Th>
                <Th textAlign="center">Nível de permissão</Th>
                <Th textAlign="center">Login</Th>
                <Th textAlign="center">Editar</Th>
              </Tr>
            </Thead>
            <Tbody>
              {loadingUsers ? (
                <Tr>
                  <Td colSpan={5}>
                    <Flex justify="center" py="1rem">
                      <CircularProgress isIndeterminate color="yooga.400" />
                    </Flex>
                  </Td>
                </Tr>
              ) : (
                users.map((user) => (
                  <Tr key={user.code}>
                    <Td textAlign="center">{user.fullName}</Td>
                    <Td textAlign="center">{user.accessLevelLabel}</Td>
                    <Td textAlign="center">{user.login}</Td>
                    <Td textAlign="center">
                      {user.fullName !== 'Usuário Temporário' && (
                        <ProtectedComponent permission="installation-card-users-update">
                          <IconButton
                            rounded="full"
                            variant="ghost"
                            aria-label="Gerar nova senha"
                            icon={<IoKeyOutline />}
                            isDisabled={d('installation-card-users-update')}
                            onClick={() => setNewPasswordUser(user)}
                          />
                        </ProtectedComponent>
                      )}
                    </Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  );
};

export default Users;
